<template>
  <div id="DashboardView" class="dashboard-view justify-content-center">
    <Header></Header>
    <div class="container dashboard-container">
      <p class="no-rights" v-if="hasNoRights">
        Please logout and login again to update your access rights.
      </p>
      <div class="row justify-content-center">
        <div class="col-3 justify-content-center" v-if="isRoutingToolEditor()">
          <div class="tools d-flex flex-column">
            <router-link :to="{ name: 'tests'}" class="py-2">
              <div class="tool-link d-flex flex-column">
                <TestToolSVG></TestToolSVG>
                <p>
                  <strong>
                    Test Tool GUI
                  </strong>
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-3 justify-content-center" v-if="isCompetitorAnalyst()">
          <div class="tools d-flex flex-column">
            <router-link :to="{ name: 'competitorLeader'}" class="py-2">
              <div class="tool-link d-flex flex-column">
                <CompetitorAnalysisSVG></CompetitorAnalysisSVG>
                <p>
                  <strong>
                    Competitor Analysis
                  </strong>
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/layout/Header'
import TestToolSVG from '@/components/svg/TestTool'
import CompetitorAnalysisSVG from '@/components/svg/CompetitorAnalysis'
import { mapGetters } from 'vuex'
export default {
  name: 'Dashboard',
  components: {
    Header,
    TestToolSVG,
    CompetitorAnalysisSVG
  },
  computed: {
    ...mapGetters({
      isRoutingToolEditor: 'auth/isRoutingToolEditor',
      isCompetitorAnalyst: 'auth/isCompetitorAnalyst',
      isWebEditor: 'auth/isWebEditor'
    }),
    hasNoRights () {
      return !this.isWebEditor() && !this.isCompetitorAnalyst() && !this.isRoutingToolEditor()
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  height: calc(100vh - 100px);
  min-height: 250px;
  .row{
    align-items: center;
    height: calc(100vh - 100px);
    min-height: 250px;
  }

  .no-rights{
    text-align: center;
    margin-top: 100px;
    color: red;
    animation: blinker 1s linear infinite;
  }
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

img {
  width: 74px;
  height: 74px;
  margin: auto;
}
a {
  color: #3B454C;

  &:hover {
    color: #3B454C;
  }
}
.pad-top-title{
  padding-top: 12px;
}
.pad-top{
  padding-top: 20px;
  p{

  }
}
.tool-link {
  text-align: center;
  height: 225px;
  width: 225px;
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.19);
  padding: 30px;
  display: block;
  margin: auto;
  float: left;

  a {
    color: #3B454C;

    &:hover {
      color: #3B454C;
    }
  }

  p{
    strong{
      font-size: 17px;
      font-weight: 500;
    }
  }
}
.test-tool-component{
  padding-top: 20px;
  padding-bottom: 20px;
}
.competitor-analysis-component{
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue